"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTestAttributes = exports.dataTestKeys = exports.buildDataTestProps = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _DocumentedComponent = require("../../types/DocumentedComponent");
var _core = require("@emotion/core");
var _excluded = ["dataTestComponent", "dataTestId"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var dataTestKeys = ['data-test-component', 'data-test-id'];
exports.dataTestKeys = dataTestKeys;
var buildDataTestProps = function buildDataTestProps(_ref) {
  var dataTestComponent = _ref.dataTestComponent,
    dataTestId = _ref.dataTestId;
  var testComponentProp = !!dataTestComponent ? {
    'data-test-component': dataTestComponent
  } : {};
  var testIdProp = !!dataTestId ? {
    'data-test-id': dataTestId
  } : {};
  return _objectSpread(_objectSpread({}, testComponentProp), testIdProp);
};
exports.buildDataTestProps = buildDataTestProps;
var withTestAttributes = function withTestAttributes(_ref2) {
  var component = _ref2.component,
    id = _ref2.id;
  return function (WrappedComponent) {
    var ComponentWithTestAttributes = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
      var _ref3$dataTestCompone = _ref3.dataTestComponent,
        dataTestComponent = _ref3$dataTestCompone === void 0 ? component : _ref3$dataTestCompone,
        _ref3$dataTestId = _ref3.dataTestId,
        dataTestId = _ref3$dataTestId === void 0 ? id : _ref3$dataTestId,
        props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
      var dataTestProps = buildDataTestProps({
        dataTestComponent: dataTestComponent,
        dataTestId: dataTestId
      });
      return (0, _core.jsx)(WrappedComponent, (0, _extends2.default)({}, dataTestProps, props, {
        ref: ref
      }));
    });
    var HoistedComponent = (0, _hoistNonReactStatics.default)(ComponentWithTestAttributes, WrappedComponent);
    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    ComponentWithTestAttributes.displayName = "withTestAttributes(".concat(displayName, ")");
    var description = (0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent) ? WrappedComponent.documentation.toJSON().description : '';
    var DocumentedComponentWithTestAttributes = (0, _stencilReactDesc.describe)(HoistedComponent).description(description);
    if ((0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent)) {
      DocumentedComponentWithTestAttributes.propTypes = _objectSpread(_objectSpread({}, WrappedComponent.describedPropTypes), {}, {
        dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
      });
    } else if (WrappedComponent.propTypes) {
      HoistedComponent.propTypes = _objectSpread(_objectSpread({}, WrappedComponent.propTypes), {}, {
        dataTestId: _propTypes.default.string
      });
    }
    if (WrappedComponent.defaultProps) {
      HoistedComponent.defaultProps = _objectSpread({}, WrappedComponent.defaultProps);
    }
    var _ref4 = WrappedComponent,
      withComponent = _ref4.withComponent;
    if (withComponent !== undefined) {
      HoistedComponent.withComponent = function (tag) {
        return withTestAttributes({
          component: component,
          id: id
        })(withComponent(tag));
      };
    }
    return DocumentedComponentWithTestAttributes;
  };
};
exports.withTestAttributes = withTestAttributes;